import axios from 'axios'

export default class DadosCadastrais {
  constructor (tokenBearer, url, id) {
    this.baseUrl = `${url}/api/unimed/dadosCadastrais`
    this.url = `${this.baseUrl}/${id}`
    
    this.tokenBearer = tokenBearer
  }

  getDadosCadastrais () {
    return new Promise(async (resolve, reject) => {
      let optionsDadosCadastrais = {
        method: 'get',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseDadosCadastrais = await axios(optionsDadosCadastrais)
        resolve(responseDadosCadastrais)
      } catch (err) {
        reject(err)
      }
    })
  }

  putDadosCadastrais (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getHistoricoDadosCadastrais (args = '') {
    return new Promise(async (resolve, reject) => {
      let optionsDadosCadastrais = {
        method: 'get',
        url: `${this.baseUrl}/historico/${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseDadosCadastrais = await axios(optionsDadosCadastrais)
        resolve(responseDadosCadastrais)
      } catch (err) {
        reject(err)
      }
    })
  }

  getHistoricoDadosCadastraisPorUnimed (idUnimed, args = '') {
    return new Promise(async (resolve, reject) => {
      let optionsDadosCadastrais = {
        method: 'get',
        url: `${this.baseUrl}/${idUnimed}/historico/${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseDadosCadastrais = await axios(optionsDadosCadastrais)
        resolve(responseDadosCadastrais)
      } catch (err) {
        reject(err)
      }
    })
  }
}
